<template>
	<v-dialog :model-value="dialog" width="460" persistent>
		<v-card>
			<v-card-title class="text-h1 font-weight-bold">
				{{ options.mode === "add" ? "Create New" : "Edit Current" }} Hot Key Page
				<v-spacer></v-spacer>
				<v-btn icon="mdi-close" @click="close" :disabled="loading" variant="plain">
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-form ref="form" v-model="valid">
					<div>
						<label class="text-caption">Name</label>
						<v-text-field
							v-model="name"
							placeholder="Enter name"
							:rules="[v => !!v || 'Name is required']"
							required
							variant="outlined" density="compact" single-line
						></v-text-field>
					</div>
					<div>
						<label class="text-caption">Rows</label>
						<v-select v-model="rows"
							:items="selectOptions"
							label="Rows"
							variant="outlined" density="compact" single-line
						></v-select>
					</div>
					<div>
						<label class="text-caption">Columns</label>
						<v-select v-model="columns"
							:items="selectOptions"
							label="Columns"
							variant="outlined" density="compact" single-line
						></v-select>
					</div>
				</v-form>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					v-if="options.mode === 'edit' || options.mode === 'delete'"
					:disabled="loading" variant="text" color="primary" @click="deletePage">
					Delete
				</v-btn>
				<v-btn
					:variant="(options.mode === 'edit') ? 'outlined' : (options.mode === 'add') ? 'text' : ''"
					:disabled="loading" color="primary" @click="close">
					Cancel
				</v-btn>
				<v-btn
					variant="flat" color="primary" :disabled="!valid || loading" :loading="loading"
					@click="saveObject">
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import PlaylistTypes from "@/enums/PlaylistTypes";

export default {
	name: "ManageHotKeyPageDialog",

	props: ["dialog", "options", "selectedStationID"],

	emits: ["delete", "close"],

	data() {
		return {
			valid: true,
			name: this.options.object.Title || "",
			rows: this.options.object.Rows || 4,
			columns: this.options.object.Columns || 3,
			selectOptions: Array.from({length: 8}, (v, i) => i + 1),   // Array containing numbers from 1 to 8
			loading: false
		}
	},

	methods: {
		saveObject() {
			if (this.$refs.form.validate()) {
				this.loading = true;

				let payload = {
					OrganizationID: this.$store.getters.getOrgID(),
					StationID: this.selectedStationID,
					PlaylistType: PlaylistTypes.HotKeyBank,
					Title: this.name,
					Rows: this.rows,
					Columns: this.columns
				};

				if (this.options.mode === "edit") {
					payload.PlaylistID = this.options.object.PlaylistID;
				}

				this.$store.dispatch(
						(this.options.mode === "add" ? "createPage" : "updatePage"),
						payload
					)
				    .then(response => {
						if (response.status == 200) {
							this.$store.commit(
								"SHOW_SUCCESS_NOTIFICATION",
								{
									message: `Hot key page successfully
                                    ${this.options.mode === "add" ? "created" : "updated"}!`
								}
							);
							if (this.options.callback) {
								this.options.callback();
							}
							this.close();
						}
						else {
							this.$store.commit(
								"SHOW_NOTIFICATION_WITH_TYPE",
								{
									message: `An error occurred when trying to
                                    ${this.options.mode === "add" ? "create" :
								      "update"} the hot key page.`
								}
							)
						}
					})
				    .finally(() => {
						this.loading = false;
					});
			}
		},

		deletePage() {
			this.$emit("delete", () => {
				this.close();
			});
		},

		close() {
			this.$emit("close");
		}
	}
};
</script>

<style lang="scss" scoped>
label {
	display: block;
	margin-bottom: 4px;
}

.v-select {
	width: 68px;
}
</style>
